export const trackContact = () => {
  if (window.fbq) window.fbq("track", "Contact");
};

export const trackLead = () => {
  if (window.fbq) window.fbq("track", "Lead");
};
